import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createClient, Environment, KameleoonProvider } from '@kameleoon/react-sdk';

// Kameleoon configuration
const configuration = {
  updateInterval: 1,
  environment: Environment.Production,
  // Must be `cookieDomain` — the SDK never reads `domain`, so that spelling was
  // silently ignored and the cookie stayed scoped to shop.gueripep.com alone.
  cookieDomain: window.location.hostname.includes('gueripep.com') ? '.gueripep.com' : undefined,
};
const kameleoonClient = createClient({ siteCode: 'dnkd8eslzh', configuration });



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <KameleoonProvider client={kameleoonClient}>
      <App />
    </KameleoonProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();